export class SubscriptionPreference {
    id: string;
    enabled: boolean;

    public static fromJson = (data: any): SubscriptionPreference => {
        const dto = new SubscriptionPreference();
        dto.id = data.Id;
        dto.enabled = data.Enabled;
        return dto;
    }
}